import React, { memo } from "react";

const LeadRow = memo(({ lead, onClick }) => (
  <tr
    className="hover:bg-gray-50 transition-colors cursor-pointer"
    onClick={() => onClick(lead)}
  >
    <td>{new Date(lead.created_at).toLocaleString('en-IN', { hour12: true })}</td>
    <td>{lead.customer?.customer_segment}</td>
    <td>₹{(parseFloat(lead.total_value) || 0).toFixed(2)}</td>
    <td>
      <span className={`status-text status-${lead.status}`}>
        {lead.status}
      </span>
    </td>
    <td>₹{(parseFloat(lead.commission_amount) || 0).toFixed(2)}</td>
    <td style={{maxWidth: 220, overflow: 'hidden', textOverflow:'ellipsis'}}>
      {lead.products && lead.products.length > 0
        ? lead.products.map(p => p.product_name).join(', ')
        : '—'
      }
    </td>
  </tr>
));

LeadRow.displayName = 'LeadRow';

export default LeadRow;


